import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// const state = {}

export default new Vuex.Store({
  state: {
    // 这里是要去管理的各组件去公用的状态
    lists: []
  },
  mutations: {
    // 这里是定义改变上面状态的方法
    addItem(state, value) {
      if (value) {
        state.lists.push(value)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js